export default "__VITE_ASSET__Dej6kG0G__"